import React from 'react';
export default (function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('panel-header-illustration'),
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "blue-strip",
    style: {
      height: props.blueStripHeight + 'px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "illustration-container"
  }, props.children));
});